import { PecSwitch, PrivateRoute } from 'components/route'
import { Redirect, useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'
import { grupoCboVisualizarAcompanhamentos } from 'view/cidadao/authorization/acessos'

import { ACOMPANHAMENTOS_PRE_NATAL_URL, ACOMPANHAMENTOS_PUERPERIO_URL } from './getAcompanhamentosSideMenuItems'
import { ExternalPaths } from './model-acompanhamentos'
import { AcompanhamentoPreNatalContent } from './pre-natal/AcompanhamentoPreNatalContent'
import { AcompanhamentoPuerperioContent } from './puerperio/AcompanhamentoPuerperioContent'

interface AcompanhamentosRootViewProps {
  prontuarioId: ID
  atendimentoId: ID
  cidadaoId: ID
  dataReferencia: Instant
  externalPaths: ExternalPaths
  isVisualizacaoProntuario: boolean
  isEscutaInicial: boolean
  redirectRoute: string
}

export function AcompanhamentosRootView(props: Readonly<AcompanhamentosRootViewProps>) {
  const {
    prontuarioId,
    atendimentoId,
    cidadaoId,
    dataReferencia,
    externalPaths,
    isVisualizacaoProntuario,
    isEscutaInicial,
    redirectRoute,
  } = props

  const basePath = externalPaths.basePath
  const match = useRouteMatch()

  const renderAcompanhamentoPreNatal = () => (
    <AcompanhamentoPreNatalContent
      prontuarioId={prontuarioId}
      atendimentoId={atendimentoId}
      cidadaoId={cidadaoId}
      dataReferencia={dataReferencia}
      externalPaths={externalPaths}
      isVisualizacaoProntuario={isVisualizacaoProntuario}
      isEscutaInicial={isEscutaInicial}
    />
  )

  const renderAcompanhamentoPuerperio = () => (
    <AcompanhamentoPuerperioContent
      prontuarioId={prontuarioId}
      cidadaoId={cidadaoId}
      atendimentoId={atendimentoId}
      dataReferencia={dataReferencia}
      externalPaths={externalPaths}
      isVisualizacaoProntuario={isVisualizacaoProntuario}
      isEscutaInicial={isEscutaInicial}
    />
  )

  return (
    <PecSwitch>
      <Redirect exact path={match.url} to={redirectRoute} />
      <PrivateRoute
        path={`${basePath}/${ACOMPANHAMENTOS_PRE_NATAL_URL}`}
        render={renderAcompanhamentoPreNatal}
        permission={Permissions.visualizarProntuario}
        cbos={grupoCboVisualizarAcompanhamentos}
      />
      <PrivateRoute
        path={`${basePath}/${ACOMPANHAMENTOS_PUERPERIO_URL}`}
        render={renderAcompanhamentoPuerperio}
        permission={Permissions.visualizarProntuario}
        cbos={grupoCboVisualizarAcompanhamentos}
      />
    </PecSwitch>
  )
}
